export type VideoConfigType = {
  hideMuteButton?: boolean;
  isDefaultMuted?: boolean;
  autoplay?: boolean;
  vimeoURL?: string;
  withButton?: {
    mute: string;
    unMute: string;
    play: string;
    pause: string;
  };
  onSoundStop(): void;
};

export type AvatarConfigType = {
  host?: unknown;
  withButton?: {
    mute: string;
    unMute: string;
  };
};

export type PolygonConfigType = { isAddingProcess?: boolean };

export type TCoordinates = {
  x: number;
  y: number;
  z: number;
};

export type TSceneInitEvent =
  | 'object'
  | 'video'
  | 'image'
  | 'html'
  | 'avatar'
  | 'polygon'
  | 'orientedBox'
  | 'shadow'
  | 'controls'
  | 'loader'
  | 'controller'
  | 'patch'
  | 'barrier'
  | 'customSweep'
  | 'pathLine'
  | 'icon'
  | 'trigger'
  | 'teleport'
  | 'pathPoint';

export enum LoadingState {
  Idle = 'Idle',
  Loaded = 'Loaded',
  Loading = 'Loading',
  Error = 'Error'
}

export type TSceneNode = [modelNode: any, component: any];

export interface TPosition {
  x: number;
  y: number;
  z: number;
}
